//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import SelectCouponModal from './components/select-coupon-modal';
import SelectMemberModal from './components/select-member-modal';
import SelectActivityModal from './components/select-activity-modal';

export default {
    name: 'couponSettings',
    components: { SelectActivityModal, SelectMemberModal, SelectCouponModal },
    data() {
        var vm = this;
        return {
            loading: false,
            saving: false,
            totalCount: 0,
            currentPage: 1,
            pageSize: 10,
            list: [],
            columns: [
                {
                    type: 'index',
                    width: 60,
                    align: 'center'
                },
                {
                    title: '事件类型',
                    align: 'center',
                    key: '',
                    render: (h, params) => {
                        const row = params.row;
                        var str = '';
                        if (row.businessType == 'Activity') {
                            str = '活动';
                        } else if (row.businessType == 'Questionnaire') {
                            str = '问卷调查';
                        } else if (row.businessType == 'GoodsOrder') {
                            str = '购买卡券商品';
                        }
                        return h('span', str);

                    }
                },
                {
                    title: '关联事件名称',
                    align: 'center',
                    key: 'activity.activityName',
                    render: (h, params) => {
                        const row = params.row;
                        var str = '';
                        if (row.businessType == 'Activity') {
                            str = row.activity.activityName;
                        } else if (row.businessType == 'Questionnaire') {
                            str = row.questionnaire.name;
                        } else if (row.businessType == 'GoodsOrder') {
                            str = row.good.goodName;
                        }
                        return h('span', str);

                    }
                },
                {
                    title: '触发事件',
                    align: 'center',
                    render: (h, params) => {
                        const row = params.row;
                        var str = '';
                        if (row.businessType == 'Activity') {
                            str = '报名成功';
                        } else if (row.businessType == 'Questionnaire') {
                            str = '回答问卷';
                        }else if (row.businessType == 'GoodsOrder') {
                            str = '购买卡券商品';
                        }
                        return h('span', str);
                    }
                },
                {
                    title: '优惠券',
                    align: 'center',
                    key: 'coupon.name',
                    render: (h, params) => {
                        return h('span', params.row.coupon.name);
                    }
                },
                {
                    title: '创建时间',
                    align: 'center',
                    key: 'creationTimeStr'
                    // render: (h, params) => {
                    //     return h('span', new Date(params.row.creationTime).toLocaleDateString());
                    // }
                },
                {
                    title: '操作',
                    align: 'center',
                    render: (h, params) => {
                        const row = params.row;
                        const actions = [];

                        var del = h('Button', {
                            props: {
                                type: 'error',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    vm.delCouponSetting(params.row);
                                }
                            }
                        }, '删除');

                        if (vm.hasPermission('Pages.MemberManage.Coupon.Delete')){
                            actions.push(del);
                        }

                        return h('div', actions);
                    }
                }
            ],
            showEditCouponSettingModel: false,
            couponSetting: {
                type: 0
            },
            rules: {
                couponName: [{ required: true, message: '请选择优惠券', trigger: 'blur' }],
                activityName: [{ required: true, message: '请选择活动', trigger: 'blur' }]
            },
            showSelectCouponModel: false,
            showSelectMemberModel: false,
            showSelectActivityModel: false
        };
    },
    methods: {
        pageChange(page) {
            // this.$store.commit('coupon/setCurrentPage', page);
            this.currentPage = page;
            this.getPage();
        },
        pageSizeChange(pagesize) {
            // this.$store.commit('coupon/setPageSize', pagesize);
            this.pageSize = pagesize;
            this.getPage();
        },
        getPage() {
            this.loading = true;
            var page = {
                maxResultCount: this.pageSize,
                skipCount: (this.currentPage - 1) * this.pageSize
            };
            abp.ajax.post('/api/services/app/EventCoupon/Search', page).then(res => {
                // this.getPage();
                this.list = [];
                this.list = res.data.result.items;
                this.totalCount = res.data.result.totalCount;
            }).finally(() => {
                this.loading = false;
            });
        },
        editCouponSetting(s) {
            this.couponSetting = s;
            this.couponSetting.type = 0;
            this.showEditCouponSettingModel = true;
        },
        onCancel() {
            this.showEditCouponSettingModel = false;
        },
        onSave() {
            console.log('111');
            this.$refs.couponForm.validate(async (val) => {
                if (val) {
                    // console.log(this.couponSetting);
                    this.saving = true;
                    abp.ajax.post('/api/services/app/EventCoupon/Add', this.couponSetting).then(res => {
                        this.showEditCouponSettingModel = false;
                        this.getPage();
                    }).finally(() => {
                        this.saving = false;
                    });
                }
            });
        },
        showAddACoupon() {
            this.showSelectCouponModel = true;
        },
        addCoupon(data) {
            // console.log(data);
            this.couponSetting.couponName = data.name;
            this.couponSetting.couponId = data.id;
            this.showSelectCouponModel = false;
        },
        addMember(data) {
            // this.couponSetting.couponName = data.name;
            // this.couponSetting.couponId = data.id;
            // console.log(data);
            this.showSelectMemberModel = false;
        },
        showAddActivity() {
            this.showSelectActivityModel = true;
        },
        addActivity(data) {
            // console.log(data);
            this.couponSetting.activityName = data.activityName;
            this.couponSetting.activityId = data.id;
            this.couponSetting.eventId = data.id;
            this.showSelectActivityModel = false;
        },
        delCouponSetting(row) {
            const vm = this;
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确认该事件吗？',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: async () => {

                    abp.ajax.delete('/api/services/app/EventCoupon/DeleteById?id=' + row.id).then(res => {
                        this.getPage();
                    }).finally(() => {
                    });
                }
            });
        },
        hasPermission(permission) {
            return abp.auth.isGranted(permission);
        }
    },
    created() {
        this.getPage();
    }
};
